import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons/faArrowRight";
import {selectSearchFlightsForm, updateDestinationAirport} from "../searchFlightsSlice";
import {fetchResults} from "../SearchFlightsActions";
import {format} from "date-fns";
import {getLocale} from "../../../utils";
import {useTranslation} from "react-i18next";
import {getAirportLabel} from "../../../utils";

function SearchDestinationsResults() {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const dateFormat = useAppSelector(
    (state) => state.config.components.dateFormat
  );
  const form = useAppSelector(selectSearchFlightsForm);
  const destinations = useAppSelector((state) => state.searchFlights.destinationsResults.results);

  const onDestinationSelect = (destination) => {
    dispatch(updateDestinationAirport(destination.location));
    dispatch(fetchResults({ queryTrigger: "destination_selection" }));
  }

  if (!destinations || destinations.length === 0) {
    return null;
  } else {
    return (
      <div id="search-destinations-results-panel">
        <h3 id="search-destinations-results-title" className="title is-5">
          {t('AVAILABLE_DESTINATIONS', {count: destinations.length, date: format(form.departingDate, dateFormat, { locale:getLocale(i18n.language)})})}
        </h3>
        <div id="search-destinations-results">
          <table className="table is-hoverable is-bordered is-fullwidth">
            <tbody>
            {destinations.map((destination, i  ) => (
              <tr key={i} onClick={(e) => onDestinationSelect(destination)}>
                <td>
                  <div className="columns is-mobile is-vcentered">
                    <div className="column is-narrow">
                      <span className="tag is-family-monospace">{destination.location.port.code}</span>
                    </div>
                    <div className="column">
                      <span>{getAirportLabel(destination.location)}</span>
                    </div>
                    <div className="column is-narrow">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default SearchDestinationsResults;